import Fonts from '@/contexts/Fonts';

export default function useGetFontSize(type: keyof typeof Fonts): number {
  return Fonts[type];
}
